import { render } from "./color.vue?vue&type=template&id=095b8204&scoped=true"
import script from "./color.vue?vue&type=script&lang=js"
export * from "./color.vue?vue&type=script&lang=js"

import "./color.vue?vue&type=style&index=0&id=095b8204&lang=scss&scoped=true"
import "./color.vue?vue&type=style&index=1&id=095b8204&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095b8204"]])

export default __exports__